<div class="footer">   
  <div class="contacts-wrapper">
    <div class="contact-column">
      <div class="contact-item">
        <img class="icon" src="assets/images/call.png" alt="telefon"> 
        <p>{{ TelefonRaluca }}</p>
      </div>
      <div class="contact-item">
        <img class="icon" src="assets/images/email_1.png" alt="email">
        <a href="mailto:{{ EmailRaluca }}" target="_blank" rel="noopener noreferrer">
          {{ EmailRaluca }}
        </a>
      </div>
      <div class="contact-item">
        <a
          class="facebook-link"
          [href]="FacebookRaluca"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <img class="facebook-icon" src="assets/images/facebook.svg" alt="">
          <span>Facebook</span>
        </a>
      </div>
      <div class="contact-item">
        <a
          class="facebook-link"
          href="https://wa.me/40745087428"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
        >
          <img class="facebook-icon" src="assets/images/whatsapp.png" alt="WhatsApp">
          <span>WhatsApp</span>
        </a>
      </div>
    </div>

    <div class="contact-column contact-action">
      <button routerLink="/send-message" class="btn-img-text">
        <img src="assets/images/send-message.jpg" alt="send-message">
        <span>{{ Trimit_mesaj }}</span>
      </button>
    </div>

    <div class="contact-column">
      <div class="contact-item">
        <img class="icon" src="assets/images/call.png" alt="telefon"> 
        <p>{{ TelefonAna }}</p>
      </div>
      <div class="contact-item">
        <img class="icon" src="assets/images/email_1.png" alt="email">
        <a href="mailto:{{ EmailAna }}" target="_blank" rel="noopener noreferrer">
          {{ EmailAna }}
        </a>
      </div>
      <div class="contact-item">
        <a
          class="facebook-link"
          href="https://wa.me/40744422011"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
        >
          <img class="facebook-icon" src="assets/images/whatsapp.png" alt="WhatsApp">
          <span>WhatsApp</span>
        </a>
      </div>
    </div>
  </div>
</div>